import { render, staticRenderFns } from "./RetailerFilter.vue?vue&type=template&id=4226b4e7&"
import script from "./RetailerFilter.vue?vue&type=script&lang=js&"
export * from "./RetailerFilter.vue?vue&type=script&lang=js&"
import style0 from "./RetailerFilter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports